import { render, staticRenderFns } from "./CellRendererDynamic.vue?vue&type=template&id=485553cd&"
import script from "./CellRendererDynamic.vue?vue&type=script&lang=ts&"
export * from "./CellRendererDynamic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports